import React from 'react'

import { Portlet, Table } from '_zari/core'

import * as InventarioService from 'services/inventario.service'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Kardex' }]

const InformeKardex = ({ sectionData }) => {
  const [detalles, setDetalles] = React.useState([])
  const [mostrarDetallesModal, setMostrarDetallesModal] = React.useState(false)
  const [modalData, setModalData] = React.useState(null)
  // const [filtros, setFiltros] = React.useState({})

  React.useEffect(() => {
    const { data } = sectionData
    // setFiltros(filtros)
    setDetalles(data)
  }, [sectionData])

  const clickVerDetalles = React.useCallback(idDetalle => {
    InventarioService.obtenerKardexDetallexIdAsConsultaModalTable(idDetalle).then(({ data }) => {
      setModalData(data)
      console.log(data)
      setMostrarDetallesModal(true)
    })
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Consulta Kardex' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Table
            title='Reporte Kardex x Cliente'
            flagDownload
            className='text-center'
            filas={detalles}
            maxRowsShown={10}
            headRows={[
              {
                label: 'FECHA',
                key: 'fecha'
              },
              {
                label: 'CODIGO',
                key: 'codigo'
              },
              {
                label: 'NOMBRE',
                key: 'nombre'
              },
              {
                label: 'ESTABLECIMIENTO',
                key: 'sede'
              },
              {
                label: 'TIPO',
                key: 'tipo'
              },
              {
                label: 'SERIE',
                key: 'serie'
              },
              {
                label: 'NUMERO',
                key: 'numero'
              },
              {
                label: 'TIPO MOV',
                key: 'tipoMov'
              },
              {
                label: 'INGRESO',
                key: 'ingreso'
              },
              {
                label: 'SALIDA',
                key: 'salida'
              },
              {
                label: 'PRECIO',
                key: 'precio'
              },
              {
                label: 'RUC',
                key: 'ruc'
              },
              {
                label: 'RAZON SOCIAL',
                key: 'razSoc'
              },
              {}
            ]}
            rowTemplate={(row, key) => (
              <Table.Row key={key}>
                <Table.Cell className='text-center'>{row.fecha}</Table.Cell>
                <Table.Cell className='text-center'>{row.codigo}</Table.Cell>
                <Table.Cell className='text-center'>{row.nombre}</Table.Cell>
                <Table.Cell className='text-center'>{row.sede}</Table.Cell>
                <Table.Cell className='text-center'>{row.tipo}</Table.Cell>
                <Table.Cell className='text-center'>{row.serie}</Table.Cell>
                <Table.Cell className='text-center'>{row.numero}</Table.Cell>
                <Table.Cell className='text-center'>{row.tipoMov}</Table.Cell>
                <Table.Cell className='text-center'>{row.ingreso}</Table.Cell>
                <Table.Cell className='text-center'>{row.salida}</Table.Cell>
                <Table.Cell className='text-center'>{row.precio}</Table.Cell>
                <Table.Cell className='text-center'>{row.ruc}</Table.Cell>
                <Table.Cell className='text-center'>{row.razSoc}</Table.Cell>
                {row.tipo ? (
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickVerDetalles(row.id)}>
                          Ver Detalles
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                ) : (
                  <Table.Cell className='text-center'></Table.Cell>
                )}
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarDetallesModal && (
        <Modals.TablaDetalleModal handleClose={() => setMostrarDetallesModal(false)} show={mostrarDetallesModal} modalData={modalData} />
      )}
    </>
  )
}

export default React.memo(InformeKardex)
